import '../assets/NcRadioGroup-BoFb0R8S.css';
import { defineComponent, useModel, ref, provide, computed, warn, openBlock, createBlock, withCtx, renderSlot, createElementBlock, normalizeClass, mergeModels } from "vue";
import { N as NcFormBox } from "./NcFormBox-wP5mpW88.mjs";
import { N as NcFormGroup } from "./NcFormGroup-B3a2iUnT.mjs";
import { I as INSIDE_RADIO_GROUP_KEY } from "./useNcRadioGroup-D6llQmAl.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcRadioGroup",
  props: /* @__PURE__ */ mergeModels({
    label: {},
    labelHidden: { type: Boolean },
    hideLabel: { type: Boolean },
    description: {}
  }, {
    "modelValue": { required: false, default: "" },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const modelValue = useModel(__props, "modelValue");
    const buttonVariant = ref();
    provide(INSIDE_RADIO_GROUP_KEY, computed(() => ({
      register,
      modelValue: modelValue.value,
      onUpdate
    })));
    function register(isButton) {
      if (buttonVariant.value !== void 0 && buttonVariant.value !== isButton) {
        warn("[NcRadioGroup] Mixing NcCheckboxRadioSwitch and NcRadioGroupButton is not possible!");
      }
      buttonVariant.value = isButton;
    }
    function onUpdate(value) {
      modelValue.value = value;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(NcFormGroup, {
        label: _ctx.label,
        description: _ctx.description,
        hideLabel: _ctx.labelHidden || _ctx.hideLabel
      }, {
        default: withCtx(() => [
          buttonVariant.value ? (openBlock(), createBlock(NcFormBox, {
            key: 0,
            row: ""
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })) : (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass(_ctx.$style.radioGroup_checkboxRadioContainer)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2))
        ]),
        _: 3
      }, 8, ["label", "description", "hideLabel"]);
    };
  }
});
const radioGroup_checkboxRadioContainer = "_radioGroup_checkboxRadioContainer_XfI2u";
const style0 = {
  "material-design-icon": "_material-design-icon_Sx-eY",
  radioGroup_checkboxRadioContainer
};
const cssModules = {
  "$style": style0
};
const NcRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcRadioGroup as N
};
//# sourceMappingURL=NcRadioGroup-LkOsE5Mc.mjs.map
